const userManageZh = {
  userManageLang: {
    账号管理: '账号管理',
    新增账号: '新增账号',
    请输入内容例如姓名手机邮箱: '请输入内容，例如姓名、手机、邮箱',
    用户类型: '用户类型',
    全部: '全部',
    管理员: '管理员',
    普通用户: '普通用户',
    查询: '查询',
    重置: '重置',
    序号: '序号',
    名称: '名称',
    邮箱: '邮箱',
    手机: '手机',
    状态: '状态',
    正常: '正常',
    删除: '删除',
    禁用: '禁用',
    角色: '角色',
    创建日期: '创建日期',
    创建人: '创建人',
    操作: '操作',
    查看: '查看',
    编辑: '编辑',
    请确认是否禁用此账号: '请确认是否禁用此账号？',
    请确认是否恢复此账号: '请确认是否恢复此账号？',
    恢复: '恢复',
    更多: '更多',
    重置密码: '重置密码',
    请确认是否删除此账号: '请确认是否删除此账号？',
    暂无数据: '暂无数据',
    基础信息: '基础信息',
    站点分配: '站点分配',
    告警配置: '告警配置',
    邮箱与手机至少填写一项用作为登录账号: '邮箱与手机至少填写一项用作为登录账号',
    登录邮箱: '登录邮箱',
    密码: '密码',
    请勾选需要分配站点名称: '请勾选需要分配站点名称！',
    全部站点: '全部站点',
    所有站点包括未来新增站点: '所有站点（包括未来新增站点）',
    平台管理员默认管理所有站点包含未来新增站点不再支持站点自由分配: '平台管理员默认管理所有站点（包含未来新增站点），不再支持站点自由分配！',
    请勾选可查看的处理建议类型: '请勾选可查看的处理建议类型！',
    全部: '全部',
    取消: '取消',
    确定: '确定',
    查看账号: '查看账号',
    账号权限: '账号权限',
    分配站点: '分配站点',

    密码重置: '密码重置',
    新密码: '新密码',
    '6-20位字符': '6-20位字符',
    确认密码: '确认密码',
    请输入确认密码: '请输入确认密码！',
    两次密码不一致请重新输入: '两次密码不一致，请重新输入！',
    请输入密码: '请输入密码！',
    请输入名称: '请输入名称！',
    请选择角色: '请选择角色！',
    请输入手机号码: '请输入手机号码！',
    请输入邮箱地址: '请输入邮箱地址！',
    请选择站点: '请选择站点！',
    编辑账号: '编辑账号',
    手机号邮箱不可同时为空: '手机号邮箱不可同时为空！',
    到期类型: '到期类型',
    永久: '永久',
    自定义时间: '自定义时间',
    到期时间: '到期时间',
    '7天': '7天',
    '15天': '15天',
    '30天': '30天',
    '6个月': '6个月',
    '1年': '1年',
    请选择到期时间: '请选择到期时间！'
  }
}
export default userManageZh
